import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-10 px-4 md:px-8" data-id="element-13">
      <div className="max-w-5xl mx-auto" data-id="element-14">
        <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-15">
          {/* Para quién ES */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} viewport={{
          once: true
        }} className="bg-[#0f1628]/50 border border-cyan-500/25 rounded-2xl p-8" data-id="element-16">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-17">
              <span className="bg-cyan-500/20 text-cyan-400 p-2 rounded-lg" data-id="element-18">
                <Check className="w-6 h-6" data-id="element-19" />
              </span>
              Para quién ES
            </h3>
            <ul className="space-y-6" data-id="element-20">
              {["Profesionales con altos niveles de estrés que no pueden 'apagar' la mente al acostarse.", 'Personas que dependen del café para sobrevivir al día y de pastillas para sobrevivir a la noche.', 'Adultos mayores de 40 años que sienten que su metabolismo se ha estancado por falta de descanso.', 'Quienes despiertan sintiéndose más cansados que cuando se acostaron.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-21">
                  <Check className="w-5 h-5 text-cyan-400 shrink-0 mt-0.5" data-id="element-22" />
                  <span className="text-[#b8c4d6]" data-id="element-23">{text}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Para quién NO ES */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} viewport={{
          once: true
        }} className="bg-[#0f1628]/50 border border-rose-500/20 rounded-2xl p-8" data-id="element-24">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-25">
              <span className="bg-rose-500/20 text-rose-400 p-2 rounded-lg" data-id="element-26">
                <X className="w-6 h-6" data-id="element-27" />
              </span>
              Para quién NO ES
            </h3>
            <ul className="space-y-6" data-id="element-28">
              {["Quienes buscan una 'pastilla mágica' para seguir con hábitos destructivos.", 'Personas que no están dispuestas a cambiar la iluminación de su dormitorio o ajustar su temperatura.', 'Personas con condiciones médicas graves que requieren supervisión clínica inmediata.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-29">
                  <X className="w-5 h-5 text-rose-400 shrink-0 mt-0.5" data-id="element-30" />
                  <span className="text-[#b8c4d6]" data-id="element-31">{text}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}